import { useParams } from 'react-router-dom';
import { CustomSupplierOfferEdit } from 'pages/admin/supplierOffers/edit';
import { SUPPLIER_OFFER_TYPE, SupplierOfferValueType } from 'models/SupplierOffer';
import { SupplierOfferEdit } from 'feature/purchaseRequestTabs/supplierOffers/edit';

export const SupplierOfferEditWrapper = () => {
  const { type } = useParams() as { type: SupplierOfferValueType };

  if (type === SUPPLIER_OFFER_TYPE.PURCHASE_REQUEST) {
    return <SupplierOfferEdit />;
  } else {
    return <CustomSupplierOfferEdit />;
  }
};
